import React from 'react';

export const IcActionsRecord = (props) => (
    <svg {...props} viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28 18C24.7 18 22 15.3 22 12C22 8.7 24.7 6 28 6V18ZM20 3V21C20 22.7 18.7 24 17 24H3C1.3 24 0 22.7 0 21V3C0 1.3 1.3 0 3 0H17C18.7 0 20 1.3 20 3ZM13 12C13 10.3 11.7 9 10 9C8.3 9 7 10.3 7 12C7 13.7 8.3 15 10 15C11.7 15 13 13.7 13 12Z" />
    </svg>
);

export default IcActionsRecord;
